import { languages } from '../i18n/languages.ts';
import de from './de.json';
import el from './el.json';
import en from './en.json';
import fr from './fr.json';
import ru from './ru.json';
import tr from './tr.json';

const resourceFiles = { de, el, en, fr, ru, tr };

// Only languages listed in i18n/languages.ts get a resource
export const translations = Object.fromEntries(
  languages.map(({ code }) => [
    code,
    resourceFiles[code as keyof typeof resourceFiles],
  ]),
) as Partial<typeof resourceFiles>;
